import { ContractModel } from "../../models/contracts/contractModel";
import { ContractsStore } from "../../store/modules/contracts";
import { ConfigStore } from "../../store/modules/config";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { PersonStore } from "../../store/modules/person";
import i18n from "@/i18n";
import Vue from "vue";

export class ContractBlockVue extends Vue {
  /** фЛАГ ОТОБОРАЖЕНИЯ В ОДНУ КОЛОНКУ */
  @Prop() isSingleCol!: boolean;

  @Prop() contract!: ContractModel;

  @Prop() depositItems!: any;

  @Prop() headerTitle!: string;

  cardsColors: Array<any> = [];

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /** Ширина окна браузера */
  get windowWidth(): number {
    return this.configStore.windowWidth;
  }

  get filteredDepositItems(): Array<any> {
    return this.depositItems.filter(
      (contract: any) =>
        (contract.IsOpen && !contract.Data.Hidden) || this.isHiddenItemsVissible
    );
  }

  get isVip(): boolean {
    return this.personStore.personInfo?.Data?.Vip;
  }

  isSelectedCard(card: any): boolean {
    if (this.contractsStore.selectedCardOrContract && (this.$route.params.cardId || this.$route.name === 'Home')) {
      if (card.Data.Id === this.contractsStore.selectedCardOrContract)
        return true;
    }
    return false;
  }

  isSelectedContract(contractId: number): boolean {
    if (this.contractsStore.selectedCardOrContract && (this.$route.params.contractId || this.$route.name === 'Home')) {
      if (contractId.toString() === this.contractsStore.selectedCardOrContract)
        return true;
    }
    return false;    
  }

  /** Флаг отображения списка скрытых счетов и карт */
  get isHiddenItemsVissible(): boolean {
    return this.configStore.isHiddenItemsVissible;
  }

  /** Флаг маскировки суммы счета */
  get isRestHiddenVissible(): boolean {
    return this.configStore.isRestHiddenVissible;
  }

  getImage(card: any): string {
    if (card.CardImageUrl !== '')
      return `background-image: url('${card.CardImageUrl}.png')`;
    return '';
  }

  toggleList(callerId: string, targetId: string) {
    const caller = document.getElementById(callerId);
    const target = document.getElementById(targetId);
    if (caller && target) {
      const isCollapsed = target.getAttribute("data-collapsed") === "true";

      if (isCollapsed) {
        this.expandSection(target);
        caller.classList.add("fs-rotate-180");
        target.setAttribute("data-collapsed", "false");
      } else {
        this.collapseSection(target);
        caller.classList.remove("fs-rotate-180");
      }
    }
  }

  /** Подпись статуса карт  */
  getCardStatus(card: any) {
    if (card.Data.CardState !== 2 && card.Data.CardState !== 1)
      return {
        status: i18n.t(`main.contracts.cardState.${card.Data.CardState}`),
        class: 'close-text'
      }
    else if (card.Data.CardState === 2)
      return {
        status: i18n.t('main.contracts.blockedCard'),
        class: 'blocked-text'
      }
    else if (card.Data.Hidden)
      return {
        status: i18n.t('main.cards.details.hideCard'),
        class: 'close-text'
      }
    return null;
  }

  collapseSection(element: any) {
    // get the height of the element's inner content, regardless of its actual size
    const sectionHeight = element.scrollHeight;

    // temporarily disable all css transitions
    const elementTransition = element.style.transition;
    element.style.transition = "";

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function() {
      element.style.height = sectionHeight + "px";
      element.style.transition = elementTransition;

      // on the next frame (as soon as the previous style change has taken effect),
      // have the element transition to height: 0
      requestAnimationFrame(function() {
        element.style.height = 0 + "px";
      });
    });

    // mark the section as "currently collapsed"
    element.setAttribute("data-collapsed", "true");
  }

  expandSection(element: any) {
    // get the height of the element's inner content, regardless of its actual size
    const sectionHeight = element.scrollHeight;

    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + "px";

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener("transitionend", function() {
      // remove this event listener so it only gets triggered once
      element.removeEventListener("transitionend", arguments.callee);

      // remove "height" from the element's inline styles, so it can return to its initial value
      element.style.height = null;
    });

    // mark the section as "currently not collapsed"
    element.setAttribute("data-collapsed", "false");
  }
}
